module.exports = __webpack_public_path__ + "img/aston-blog-list.4b058866.webp";